import { getConfig } from '@cian/config/browser';
import { getBaseUrlFromConfig } from './URI.mjs';
import '@cian/peperrors/shared';
import 'url-parse';
import { mergePaths, transformObjectToQuery } from '../../../shared/URI/helpers.mjs';

function createURL(params) {
    const { model, subdomain, transformBodyToLegacyString } = params;
    const baseUrl = getBaseUrlFromConfig(getConfig(), model);
    const url = new URL(baseUrl);
    if (subdomain) {
        url.hostname = `${subdomain}.${url.hostname}`;
    }
    url.pathname = mergePaths(url.pathname, model.pathApi);
    if (model.method === 'GET' && model.parameters) {
        url.search = transformObjectToQuery(model.parameters, transformBodyToLegacyString);
    }
    return url;
}

export { createURL };
//# sourceMappingURL=URL.mjs.map
